export default class AffirmUtils {
  static load(key, url) {
    if (window.affirm) {
      return;
    }
    const affirmConfig = {
      public_api_key: key,
      script: url,
    };

    // (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,affirmConfig,"affirm","checkout","ui","script","ready");

    /*eslint-disable */
    (function (l, g, m, e, a, f, b) {
      let d;
      const c = l[m] || {};
      const h = document.createElement(f);
      const n = document.getElementsByTagName(f)[0];
      const k = function (a, b, c) {
        return function () {
          a[b]._.push([c, arguments]);
        };
      };
      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);
      a = 0;
      for (b = 'set add save post open empty reset on off trigger ready setProduct'.split(' '); a < b.length; a++)d[b[a]] = k(c, e, b[a]);
      a = 0;
      for (b = ['get', 'token', 'url', 'items']; a < b.length; a++)d[b[a]] = function () {};
      h.async = !0;
      h.src = g[f];
      n.parentNode.insertBefore(h, n);
      delete g[f];
      d(g);
      l[m] = c;
    }(window, affirmConfig, 'affirm', 'checkout', 'ui', 'script', 'ready'));
    /* eslint-enable */
  }

  static refresh(config) {
    AffirmUtils.load(config.affirmKey, config.affirmUrl);
    try {
      window.affirm.ui.ready(function(){
        window.affirm.ui.refresh();
      });
    } catch(e) {
      console.error('Failed to refresh Affirm');
      console.error(e);
    }
  }


  static async estimatePayment(amount, config, promo) {
    AffirmUtils.load(config.affirmKey, config.affirmUrl); // loading in 2 places?
    return new Promise((resolve, reject) => {
      if (!amount || amount < 5000 || amount > 3000000) {
        throw new Error('Unable to provide Affirm estimates for amounts less than $50 or more than $30000');
      }

      const options = {
        apr: (promo === "bf" || promo === "cm") ? '0' : '0.10', // percentage assumed APR for loan
        months: 12, // can be 3, 6, or 12
        amount, // USD cents
      };

      if (affirm && affirm.ui && affirm.ui.ready) {
        affirm.ui.ready(() => {
          if (affirm && affirm.ui && affirm.ui.payments && affirm.ui.payments.get_estimate) {
            affirm.ui.payments.get_estimate(options, (paymentEstimate) => {
              // pending affirm response
              // const dollars = ( ( payment_estimate.payment + 99 ) / 100 ) | 0; // get dollars, round up, and convert to int
              // Set affirm payment text
              // const a = document.getElementById('learn-more');
              // const iText = ('innerText' in a)? 'innerText' : 'textContent';
              // a[iText] = "Starting at $" + dollars + " a month. Learn More";
              // // open the customized Affirm learn more modal
              // a.onclick = payment_estimate.open_modal;
              // a.style.visibility = "visible";

              // eslint-disable-next-line no-bitwise
              const dollars = ((paymentEstimate.payment + 99) / 100) | 0; // get dollars, round up, and convert to int
              resolve({
                dollars,
                perMonth: `As low as $${dollars}/month`,
                openModal: paymentEstimate.open_modal,
              });
            });
          }
        });
      }
    });
  }
}


